const isKeyInNavItem = (verticalNavItem, homeKey) => {
  if (verticalNavItem.id === homeKey) {
    return true;
  }
  if (verticalNavItem.children) {
    for (const child of verticalNavItem.children) {
      if (isKeyInNavItem(child, homeKey)) {
        return true;
      }
    }
  }
  return false;
};
export const getPrimaryNavItemForKey = (homeKey, navItemState) => {
  const navItems = navItemState.primaryNav.navItems;
  const primaryNavItem = navItems.find(item => isKeyInNavItem(item, homeKey));
  if (!primaryNavItem) {
    return null;
  }
  return primaryNavItem;
};